export const FORM_TABLE_FIRST_COLUMN_NAME = 'rowItemName';
export const FORM_TABLE_COLUMN_NAME = 'column';
